// Material 3 Banner: inline, persistent message with icon and optional dismiss. Replaces MUI <Alert>.
// severity: 'error' | 'warning' | 'success' | 'info'  (M3 has no status roles, so containers come from error/tertiary/primary/secondary)
(function () {
  const { Box, Typography } = MaterialUI;

  const SEVERITY = {
    error: { icon: 'error', bg: 'var(--m3-error-container)', fg: 'var(--m3-on-error-container)', role: 'alert' },
    warning: { icon: 'warning', bg: 'var(--m3-tertiary-container)', fg: 'var(--m3-on-tertiary-container)', role: 'alert' },
    success: { icon: 'check_circle', bg: 'var(--m3-primary-container)', fg: 'var(--m3-on-primary-container)', role: 'status' },
    info: { icon: 'info', bg: 'var(--m3-secondary-container)', fg: 'var(--m3-on-secondary-container)', role: 'status' }
  };

  function Banner({ severity = 'info', icon, onClose, children, sx = {} }) {
    const { GoogleIcon, IconButton } = window.Components;
    const s = SEVERITY[severity] || SEVERITY.info;
    return (
      <Box
        role={s.role}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          px: 2,
          py: 1.25,
          borderRadius: 'var(--m3-shape-medium)',
          backgroundColor: s.bg,
          color: s.fg,
          ...sx
        }}
      >
        <GoogleIcon name={icon || s.icon} size={22} filled />
        <Typography variant="body2" component="div" sx={{ flex: 1, color: 'inherit' }}>{children}</Typography>
        {onClose && (
          <IconButton size="small" onClick={onClose} aria-label="Dismiss" sx={{ color: 'inherit' }}>
            <GoogleIcon name="close" size={18} />
          </IconButton>
        )}
      </Box>
    );
  }

  window.Components = window.Components || {};
  window.Components.Banner = Banner;
})();
